import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-swipe',
  templateUrl: './alert-swipe.component.html',
  styleUrls: ['./alert-swipe.component.css']
})
export class AlertSwipeComponent implements OnInit {

    message ="";
    className = "x";
    alertSwipe = false;
    

  constructor() { }

  ngOnInit(): void {
    
  }

  sliderAlertSwipe(messageObj){
    this.message = messageObj.messageVal;
    this.className = messageObj.classVal;
    this.alertSwipe = messageObj.showAlertSwipe

    
    setTimeout(()=>{                           
      this.className = "x";
      }, 2000);
    
  }
  // ngAfterViewInit(){
  //   console.log("do ngAfterViewInit");
  // }
  // ngDoCheck(){
  //   console.log("do check");
  // }

  
}
